export default class TryAPI {

    static baseUrl = typeof window === 'undefined' || window.location.href.indexOf('geocod.io') === -1 ? 'https://api.geocodio.dev/v1.7' : 'https://api.geocod.io/v1.7';

    static geocode(query, fields, direction) {
        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        const endpoint = direction === 'forward'
          ? 'geocode'
          : 'reverse';

        const url = `${TryAPI.baseUrl}/${endpoint}?q=${encodeURIComponent(query)}&fields=${encodeURIComponent(fields.join(','))}&api_key=DEMO`;

        return fetch(url, options);
    }

}
